// extracted by mini-css-extract-plugin
module.exports = {"embedOverlay":"_263s-","eporner":"V8FEg","switch":"_2hskq","folded":"_3eGH_","flash1":"_1rcrj","flash2":"_3BygS","overlayText":"_57KLG"};